.
<template>
  <form class="grid grid-cols-12 gap-4 px-4" id="caregiverW4info" @submit.prevent="save()">
    <div class="col-span-full">
      <label class="block text-gray-700">{{ $t('common.form.filingStatus') }} <span class="text-gtRed500">*</span> </label>
      <div class="mt-3">
        <div class="flex items-center">
          <input 
            required
            v-model="caregiverW4info.filingStatus" 
            type="radio" 
            name="filingStatus" 
            :value="1" 
            class="focus:ring-gtBlue500 form-radio h-4 w-4 text-gtBlue600 border-gray-300" 
          />
          <span class="ml-3 block text-gray-700">{{ $t('common.form.filingStatus.single') }}</span>
        </div>

        <div class="flex items-center">
          <input 
            required
            v-model="caregiverW4info.filingStatus" 
            type="radio" 
            name="filingStatus" 
            :value="2" 
            class="focus:ring-gtBlue500 form-radio h-4 w-4 text-gtBlue600 border-gray-300" 
          />
          <span class="ml-3 block text-gray-700">{{ $t('common.form.filingStatus.married') }}</span>
        </div>

        <div class="flex items-center">
          <input 
            required
            v-model="caregiverW4info.filingStatus" 
            type="radio" 
            name="filingStatus" 
            :value="3" 
            class="focus:ring-gtBlue500 form-radio h-4 w-4 text-gtBlue600 border-gray-300" 
          />
          <span class="ml-3 block text-gray-700">{{ $t('common.form.filingStatus.house') }}</span>
        </div>
      </div>
    </div>

    <div class="col-span-full md:col-span-4">
      <label class="block text-gray-600">
        {{ $t('common.form.children') }}
      </label>
      <div class="flex items-center mt-1">
        <select required
          oninvalid="this.setCustomValidity('Please select a value')"
          oninput="this.setCustomValidity('')"
          v-model="caregiverW4info.dependentsChildren" 
          class="chevron-down min-w-full mb-1 block w-full bg-white rounded-md surrounding-shadow py-1 px-3 focus:outline-none text-gray-800 h-8" 
        >
          <option value="" hidden>{{ $t('common.form.children.select') }}</option>
          <option v-for="index in 21" :key="index" :value="(index - 1) * 2000"> {{ index - 1 }} - ${{ (index - 1) * 2000 }} </option>
        </select>
        <span class="w-14 -ml-8">
          <svg class="h-4 w-6 text-gtGray500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </span>
      </div>
    </div>
    <div class="col-span-full md:col-span-4 self-end">
      <label class="block text-gray-600">
        {{ $t('common.form.dependents') }}
      </label>
      <div class="flex items-center mt-1">
        <select required
          oninvalid="this.setCustomValidity('Please select a value')"
          oninput="this.setCustomValidity('')"
          v-model="caregiverW4info.dependentsOther" 
          class="chevron-down min-w-full mb-1 block w-full bg-white rounded-md surrounding-shadow py-1 px-3 focus:outline-none text-gray-800 h-8" 
        >
          <option value="" hidden>{{ $t('common.form.dependents.select') }}</option>
          <option v-for="index in 21" :key="index" :value="(index - 1) * 500"> {{ index - 1 }} - ${{ (index - 1) * 500 }} </option>
        </select>
        <span class="w-14 -ml-8">
          <svg class="h-4 w-6 text-gtGray500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </span>
      </div>
    </div>

    <div class="col-span-full md:col-span-4 self-end">
      <label class="block text-gray-600">
        {{ $t('common.form.dependents.total') }}
      </label>
      <div class="flex items-center mt-1">
        <span class="flex text-gray-800 h-8 mb-1 w-full bg-paleBlue rounded-md surrounding-shadow py-1 px-3 focus:outline-none">
          ${{ (caregiverW4info.dependentsChildren || 0) + (caregiverW4info.dependentsOther || 0) }}
        </span>
      </div>
    </div>

    <div class="col-span-full">
      <label class="block text-gray-600" v-html="$t('common.form.additionalWithholding')"></label>
      <div class="flex items-center mt-1">
        <span class="flex text-gray-800 h-8 mb-1 w-full bg-white rounded-md surrounding-shadow py-1 px-3 focus:outline-none">
          $ <input type="number" v-model="caregiverW4info.withholdingExtra" class="w-full h-full bg-transparent" />
        </span>
      </div>
    </div>

    <div class="col-span-full">
      <label class="block text-gray-600" v-html="$t('common.form.withholdingExempt', { year, lastYear: year - 1})"></label>
      <div class="flex flex-row items-center mt-4">
        <input type="checkbox" v-model="caregiverW4info.withholdingExempt" class="mr-2 relative flex items-center" />
        <label class="block text-gray-600" v-html="$t('common.form.withholdingExemptCheckbox')"></label>
      </div>
    </div>
  </form>
  <ContinueBackButtons :form="'caregiverW4info'" @back="back"></ContinueBackButtons>
</template>

<script>
import { getCurrentDate, getFormattedDate } from 'Utilities/helper';
import ContinueBackButtons from 'Views/Shared/ContinueBackButtons.vue';
import { mask } from 'vue-the-mask';
import moment from 'moment';

export default {
  directives: { mask },
  props: ['caregiverData'],
  components: { ContinueBackButtons },
  emits: ['save', 'back'],
  data() {
    return {
      caregiverW4info: {
        step: 9,
        filingStatus: '',
        dependentsChildren: '',
        dependentsOther: '',
        withholdingExtra: '',
        withholdingExempt: '',
      },
      year: moment().year()
    };
  },

  watch: {
    caregiverData(data) {
      if (data) {
        this.caregiverW4info = data;
      }
    },
  },

  methods: {
    getFormattedDate,
    getCurrentDate,
    save() {
      this.$emit('save', this.caregiverW4info);
    },

    back() {
      this.$emit('back');
    },
  },
};
</script>
